import { memo } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BzModal, BzModalHeader, BzModalBody, BzChip, BzButton, BzModalFooter, BzLoader } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import {
    cancelSingleScripOrder, cancelSipOrder, getAllGtdOrders, getAllMultiScripOrders, getAllOrders,
    getAllSipOrders, getAllSpreadOrdersSuccess, getAllSpreadOrders, orderEntryApiPending, getAllMultilegOrdersSuccess
} from "../../redux/actions/orders";
import { OrderStatus } from '.';
import { API_CODES, FACILITY_NUM, MARKET_SEGMENT_ID, ORDERBOOK_API_ORDER_STATUS, ORDERS_LIMIT_IN_API, ORDERS_TABKEY, ORDER_TYPES, ORDER_VALIDITY, TL_INDEX } from '../../utils/global_variables';
import { _cancelGtdOrder } from '../../controllers/orders';
import { OrderDisplayDescription } from '../Orders';
import { ORDERS_GRID_REF, collapseRow, getApiExchangeNameFromMktSegId, getOrderDisplayDiscription, getQtyType } from '../../utils/global_functions';
import moment from 'moment';
import { cancelMultilegOrder } from '../../apis/transactional';
import { toastConfig } from '../../redux/actions/toast';
import { sendTouchlineRequest } from '../../apis/web_socket';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';
const isHistoryAllowed = true;
const CancelOrderModal = (props) => {
    // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
    const { activeContent, ordersTabKey } = props;
    // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End

    const dispatch = useDispatch();
    const orderInfo = useSelector(state => state.orders?.orderInfo);
    const objCFT = useSelector(state => state?.auth?.objCFT);
    const bIsOrderEntryApiPending = useSelector(state => state.orders.bIsOrderEntryApiPending);
    const { modals } = useSelector(state => state.modals);
    const handleClose = () => {
        dispatch(handleModal([{ 'CANCEL_ORDER_MODAL': false }]));
    };

    const handleCancelOrder = async () => {
        if (activeContent === ORDER_TYPES.SINGLE_SCRIP) {
            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  cancel order not working – Start
            dispatch(cancelSingleScripOrder({ orderNo: orderInfo?.orderNo, exchange: orderInfo.exchangeSegment })).then((objResp) => {
                collapseRow(ORDERS_GRID_REF, false, 'orderNo', orderInfo);
                dispatch(handleModal([{ 'CANCEL_ORDER_MODAL': false }, { 'ORDER_STATUS': true }], true));
                dispatch(handleModalData({ data: { isCancel: true, orderEntryTab: ORDER_TYPES.SINGLE_SCRIP, objScripData: orderInfo } }));
                setTimeout(() => {
                    if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
                        dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));
                    } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
                        dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }));
                    }
                    dispatch(handleModal([{ 'ORDER_STATUS': false }]));
                }, 5000);
            }).catch((error) => {
                console.log(error);
                dispatch(toastConfig({ show: true, autoDismiss: true, message: 'Failed to submit cancel orders request' }));
                dispatch(handleModal([{ "CANCEL_ORDER_MODAL": false }]));
            });
            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  cancel order not working – End
        } else if (activeContent === ORDER_TYPES.GOOD_TILL_DATE) {
            const validDays = orderInfo?.validity === ORDER_VALIDITY.GTT ? 0 : orderInfo?.validity_days;
            const { status, data = {} } = await _cancelGtdOrder({ orderNo: orderInfo?.order_id, exchange: orderInfo.exchange, validity: orderInfo?.validity, validity_days: validDays });
            if (status) {
                setTimeout(() => {
                    if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
                        dispatch(getAllGtdOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));
                    } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
                        dispatch(getAllGtdOrders({ offSet: 1, limit: 20, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }));
                    }
                    dispatch(handleModal([{ 'ORDER_STATUS': false }]));
                }, 5000);
                dispatch(handleModalData({ data: { isCancel: true, orderEntryTab: ORDER_TYPES.GOOD_TILL_DATE, orderId: data?.orderId, objScripData: orderInfo } }));
                dispatch(handleModal([{ 'CANCEL_ORDER_MODAL': false }, { 'ORDER_STATUS': true }], true));
            } else {
                dispatch(toastConfig({ show: true, autoDismiss: true, message: 'Failed to submit cancel orders request' }));
                dispatch(handleModal([{ "CANCEL_ORDER_MODAL": false }]));
            }
        } else if (activeContent === ORDER_TYPES.MULTI_LEG) {
            const exchangeNameById = getApiExchangeNameFromMktSegId(orderInfo[0]?.segmentId);
            let multiLegInfo =
            {
                "type": `${orderInfo?.length}L`,
                "validity": "IOC",
                "order_time": 0,
                "prot_perc": "",
                "leg_details": []

            };
            multiLegInfo.leg_details = orderInfo?.map((element, i) => {
                return {
                    leg_no: i + 1,
                    transaction_type: element?.activeButtonToggleIndex === 0 ? "BUY" : "SELL",
                    scrip_info: {
                        exchange: exchangeNameById,
                        scrip_token: element?.token,
                        symbol: element?.symbol?.trim(),
                        series: "XX",
                        expiry_date: moment(element?.expiryDate).format("DDMMMYYYY").toUpperCase(),
                        strike_price: "",
                        option_type: element?.optiontype === "NA" ? "" : element?.optiontype,
                        instrument_name: orderInfo[0]?.instrument?.trim(),
                    },
                    quantity: element?.quantity || 1,
                    price: element?.legPrice,
                    others: {
                        market_lot: element?.ask_qty,
                        price_tick: element?.priceTick,
                        decimal_loc: element?.decLoc,
                    },
                };
            });
            const { status, data = {} } = await cancelMultilegOrder({ gateway_order_no: orderInfo[0].gatewayOrderNo, data: multiLegInfo });
            if (status) {
                //dispatch(getAllMultiLegOrderSuccess([]));
                dispatch(getAllMultilegOrdersSuccess([])); // // Ajitesh 15-07-2024 - Multileg Pagination
                setTimeout(() => {
                    dispatch(getAllMultiScripOrders({ offSet: 1, limit: 20, multileg: true, orderStatus: -1 }));
                }, 1500);
                dispatch(handleModalData({ data: { isCancel: true, orderEntryTab: ORDER_TYPES.MULTI_SCRIP, orderId: data?.data?.orderId, objScripData: { title: multiLegInfo?.leg_details[0]?.scrip_info.symbol } } }));
                dispatch(handleModal([{ 'CANCEL_ORDER_MODAL': false }, { 'ORDER_STATUS': true }], true));
            }
        } else if (activeContent === ORDER_TYPES.SPREAD) {
            dispatch(orderEntryApiPending(true));
            sendTouchlineRequest([{ exchangeId: orderInfo[0]?.segment_id, token: orderInfo[0]?.leg_no_1?.scrip_token }, { exchangeId: orderInfo[1]?.segment_id, token: orderInfo[1]?.leg_no_2?.scrip_token }]);
            const exchangeNameById = getApiExchangeNameFromMktSegId(orderInfo[0]?.segmentId);
            var multiLegInfo =
            {
                "type": "SPREAD",
                "validity": "DAY",
                "order_time": orderInfo[0]?.timestamp,
                "prot_perc": "",
                "priceDiff": orderInfo[0]?.legPrice,
                "leg_details": []

            };
            let info = dispatch(getWfhTouchlineLastTick());
            multiLegInfo.leg_details = orderInfo?.map((element, i) => {
                return {
                    leg_no: i + 1,
                    transaction_type: element?.activeButtonToggleIndex === 0 ? "BUY" : "SELL",
                    scrip_info: {
                        exchange: exchangeNameById,
                        scrip_token: element?.token,
                        symbol: element?.symbol?.trim(),
                        series: "XX",
                        expiry_date: moment(element?.expiryDate).format("DDMMMYYYY").toUpperCase(),
                        strike_price: "",
                        option_type: element?.optiontype === "NA" ? "" : element?.optiontype,
                        instrument_name: orderInfo[0]?.instrument?.trim(),
                    },
                    quantity: element?.quantity || 1,
                    price: info?.[orderInfo[0]?.segment_id + '_' + element?.scrip_token]?.[TL_INDEX.LAST_TRADE_PRICE] || "0.00",
                    others: {
                        market_lot: element?.ask_qty,
                        price_tick: element?.priceTick,
                        decimal_loc: element?.decLoc,
                    },
                };
            });
            const { status, data = {} } = await cancelMultilegOrder({ gateway_order_no: orderInfo[0].gatewayOrderNo, data: multiLegInfo });
            if (status) {
                dispatch(getAllSpreadOrdersSuccess([]));
                setTimeout(() => {
                    dispatch(getAllSpreadOrders({ offSet: 1, limit: 20, spread: true, orderStatus: -1 }));
                }, 1500);
                dispatch(handleModalData({ data: { isCancel: true, orderEntryTab: ORDER_TYPES.MULTI_SCRIP, orderId: data?.data?.orderId, objScripData: { title: multiLegInfo?.leg_details[0]?.scrip_info.symbol } } }));
                dispatch(handleModal([{ 'CANCEL_ORDER_MODAL': false }, { 'ORDER_STATUS': true }], true));
            }
            dispatch(orderEntryApiPending(false));
        }
        else {
            // Vinit R : 11-07-2024 :BT-107418 :Breeze - Order Book - SIP Order  -- Start           
            const data = {
                sip_id: orderInfo?.id,
                status: orderInfo?.status === 'ACTIVE' ? 'PENDING' : orderInfo?.status,
                transaction_type: orderInfo?.transaction_type,
                invested_by: orderInfo?.investment_type,
                company_name: orderInfo?.symbol,
                newStatus: ""
            };
            // Vinit R : 11-07-2024 :BT-107418 :Breeze - Order Book - SIP Order  -- End           
            dispatch(cancelSipOrder(data))?.then((resp) => {
                if (resp?.data.code === API_CODES.ECODE_SUCCESS) {

                    dispatch(handleModal([{ 'CANCEL_ORDER_MODAL': false }, { 'ORDER_STATUS': true }], true));
                    dispatch(handleModalData({ data: { isCancel: true, orderEntryTab: 'sip', id: orderInfo?.id } }));
                    //auto colose order status modal start
                    setTimeout(() => {
                        if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
                            dispatch(getAllSipOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }, isHistoryAllowed));
                        } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
                            dispatch(getAllSipOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }, isHistoryAllowed));
                        }
                        dispatch(handleModal([{ 'ORDER_STATUS': false }]));
                    }, 5000);
                    //auto colose order status modal end

                }

            }).catch((error) => {
                console.log(error);
            });
            // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
        }
    };

    return (
        <>
            <BzModal data-testid="orders-cancel-order-modal" className='modal-breeze' show={modals['CANCEL_ORDER_MODAL']} onHide={handleClose} centered>
                <BzModalHeader className='modaltabs-header'> {/*Hari P: 29-11-2023 class added class for alignment*/}
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-items-center'>
                                <div data-testid="orders-cancel-order-modal-title" className='font-medium font-size4 color-text'>Cancel Order</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-items-center'>
                                <div data-testid="orders-cancel-order-modal-close-icon" className='icon-16 icon-close icon-dark' onClick={handleClose}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    {bIsOrderEntryApiPending ? <div className='order-entry-spinner-overlay h-100 w-100 d-flex justify-content-center align-item-center'>
                        <BzLoader spinner={bIsOrderEntryApiPending} spinnerContent="Placing Order" bIsFfromModal={true} />
                    </div> : null}
                    <Container fluid className='p-0'>
                        <Row className='g-0 pb-2 mb-2 bdr-btm'>
                            <Col>
                                <div data-testid="orders-cancel-order-modal-confirmation-text" className='font-regular font-size4 color-text'>Are you sure you want to cancel the following orders?</div>
                            </Col>
                        </Row>
                        <Row className='g-0'>
                            <Col>
                                {orderInfo?.length ? orderInfo.map((x, index) => {
                                    return <Row className='g-0 my-3'>
                                        <Col md={6} className='flex-column justify-content-start align-self-center'>
                                            <div className='d-flex'>
                                                <div data-testid={`cancel-order-modal-scrip-symbol-${index}`} className='font-medium font-size3 color-text me-2'>{x?.symbol || x?.title}</div>
                                                <div className='chips-wrap me-2'>
                                                    <BzChip data-testid={`cancel-order-modal-scrip-exchange-${index}`} className='exchange-chip'>{x?.exchange?.split('_')[0]}</BzChip>
                                                </div>
                                                <OrderDisplayDescription objRowData={x} />
                                            </div>
                                            <div className='font-regular font-size2 color-subtext me-2'>
                                                <span data-testid={`cancel-order-modal-scrip-order-type-${index}`} className={`font-medium ${(x?.transaction_type?.toUpperCase() === 'BUY' || x?.type?.toUpperCase() === 'BUY') ? 'color-positive' : 'color-negative'}`}>{x?.transaction_type || x?.type}: </span>
                                                {x?.invested_qty_or_val || x?.totalQuantity} {getQtyType(x?.exchange)} @ &#8377;{orderInfo[0]?.cap_price || orderInfo[0]?.price}
                                            </div>
                                        </Col>
                                        <Col md={6} className='d-flex flex-column align-items-end'>
                                            <div data-testid={`cancel-order-modal-scrip-order-status-${index}`} className='font-regular font-size2 color-subtext'>Open</div>
                                            <div data-testid={`cancel-order-modal-scrip-pending-quantity-${index}`} className='font-medium font-size2 color-text'>{x?.pendingQuantity} {getQtyType(x?.exchange)}</div>
                                        </Col>
                                    </Row>;
                                }) :
                                    <Row className='g-0 align-items-start my-3'>
                                        <Col md={10}>
                                            <div className=''>
                                                <div className='d-flex'>
                                                    <div data-testid="orders-cancel-order-modal-scrip-symbol" className='font-medium font-size4 color-text me-2'>{orderInfo?.symbol || orderInfo?.title}</div>
                                                    <div className='chips-wrap me-2'>
                                                        <BzChip data-testid="orders-cancel-order-modal-scrip-exchange" className='exchange-chip'>{orderInfo?.exchange?.split('_')[0]}</BzChip>
                                                    </div>
                                                    <div className='font-regular font-size4 color-subtext'>{getOrderDisplayDiscription(orderInfo)}</div>
                                                </div>
                                                <div className='font-regular font-size2 color-subtext me-2'>
                                                    <span data-testid="orders-cancel-order-modal-scrip-order-type" className={`font-medium ${(orderInfo?.transaction_type?.toUpperCase() === 'BUY' || orderInfo?.type?.toUpperCase() === 'BUY') ? 'color-positive' : 'color-negative'}`}>{orderInfo?.transaction_type || orderInfo?.type}:</span>
                                                    <span data-testid="orders-cancel-order-modal-scrip-invested-quantity" className='ms-1'>{orderInfo?.invested_qty_or_val || orderInfo?.totalQuantity} {orderInfo?.investment_type || getQtyType(orderInfo?.exchange)} @ &#8377;{orderInfo?.cap_price || orderInfo?.price}</span>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={2} className='text-end'>
                                            <div data-testid="orders-cancel-order-modal-scrip-order-status" className='font-regular font-size2 color-subtext'>Open</div>
                                            <div data-testid="orders-cancel-order-modal-scrip-pending-quantity" className='font-medium font-size2 color-text'>{orderInfo?.pendingQuantity} {getQtyType(orderInfo?.exchange)}</div>
                                        </Col>
                                    </Row>
                                }
                            </Col>
                        </Row>
                        {((activeContent === ORDER_TYPES.SINGLE_SCRIP && (orderInfo?.validity_date || orderInfo?.validity === ORDER_VALIDITY.GTD)) || activeContent === ORDER_TYPES.GOOD_TILL_DATE) && (objCFT?.GTTSUPPORT === FACILITY_NUM.OFF || orderInfo?.validity === ORDER_VALIDITY.GTD) ?
                            <Row className='g-0 alert-warning mt-4 p-2'>
                                <Col md={12} className='d-flex justify-content-start align-items-start'>
                                    <div className='icon-20 icon-info icon-dark me-1'></div>
                                    <div className='font-medium font-size3 color-text'>{activeContent === ORDER_TYPES.SINGLE_SCRIP && (orderInfo?.mktId === MARKET_SEGMENT_ID.NSE_CASH || orderInfo?.mktId === MARKET_SEGMENT_ID.BSE_CASH || orderInfo?.mktId === MARKET_SEGMENT_ID.MSX_CASH) ? "GTD order shall be Cancelled only for the current day. Do you wish to continue?" : "GTD order shall be cancelled permanently. Do you wish to continue?"}</div>
                                </Col>
                            </Row> : null}
                    </Container>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0 m-0'>
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-end'>
                                <BzButton data-testid='orders-cancel-order-modal-close-button' className='btn btn-md btn-outline text-uppercase me-2' onClick={handleClose}>CLOSE</BzButton>
                                <BzButton data-testid='orders-cancel-order-modal-cancel-order-button' className='btn btn-md btn-primary text-uppercase ms-2' onClick={handleCancelOrder}>CANCEL ORDER</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>
            <OrderStatus />
        </>
    );
};

export default memo(CancelOrderModal);
